import * as React from "react";
import { getTheme } from "@warda/library-ui/theme";
import CardTitle from "../CardTitle";
const CardPortalSignup = ({ cardClasses, dispatch, notifDrc }) => {
    const { payload } = notifDrc;
    const { portalName } = payload;
    return (React.createElement(CardTitle, { classes: cardClasses, dispatch: dispatch, avatarIcon: "pending_actions", avatarColor: getTheme().colors.msgWarn, title: `Request sign up for portal "${portalName}"`, notifDrc: notifDrc }));
};
export default CardPortalSignup;
